module.exports = __webpack_public_path__ + "media/images/remove-file-91d58169.png";